module.exports = __webpack_public_path__ + "img/boxBgImg.19bebcbb.svg";